<script>
export default {
  name: "laTeXEditorModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "visible",
    event: "visible",
  },
  data() {
    return {
      laTeXEditorText: "",
      laTeXEditorHtml: "",
    };
  },
  methods: {
    modalOk() {
      this.$emit("ok", this.laTeXEditorHtml);
      this.modalCancel();
    },
    modalCancel() {
      this.$emit("visible", false);
      this.laTeXEditorText = "";
      this.laTeXEditorHtml = "";
    },
    laTeXEditorChange(e) {
      const result = MathJax.tex2svg(e.target.value);
      const blob = new Blob([result.innerHTML], {
        type: "image/svg+xml",
      });
      const fileReader = new FileReader();
      fileReader.readAsDataURL(blob);
      fileReader.onload = e => {
        this.laTeXEditorHtml = `<img src="${e.target.result}">`;
      };
    },
  },
};
</script>

<template>
  <a-modal title="LaTeX" :visible="visible" @ok="modalOk" @cancel="modalCancel" width="800px" centered>
    <div class="laTeX-editor">
      <a-textarea v-model="laTeXEditorText" @blur="laTeXEditorChange" placeholder="请输入LaTeX文档" :auto-size="{ minRows: 3, maxRows: 5 }" />
      <div v-html="laTeXEditorHtml" style="min-height: 200px;margin-top: 24px;"></div>
    </div>
  </a-modal>
</template>

<style scoped lang="less">
.laTeX-editor {
  min-height: 300px;
}
</style>
